import {StoriesMap} from '../../../stories/ImportStoriesToBuild';
import {CreateJSInstance} from '../../../stories/CreateJSInstance';
// import {PIXIInstance} from '../../../stories/PIXIInstance';

const _packs = {};
const _packsExists = {};

export const storeStoriesPack = (pack, path) => {
    _packs[path] = pack;
    _packsExists[path] = true;
};

export const hasStoriesPack = path => {
    return _packsExists[path];
};

export const Factory = () => {
    return storyId => {
        const path = StoriesMap[storyId];
        const pack = _packs[path];
        let instance = {};

        if (pack.isCreateJS) {
            instance = CreateJSInstance(pack);
        }

        /* if (pack.isPIXI) {
            instance = PIXIInstance(pack);
        }*/

        return {
            pack,
            domElement: instance.domElement,
            stage: instance.stage,
            mainView: instance.mainView,
            resizeMainView: instance.resizeMainView,
            resizeCanvas: instance.resizeCanvas,
            render: instance.render
        };
    };
};
